import { defineElement } from '~/utils/gw-utils';

class VideoCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiperLoader = this.querySelector('swiper-loader');
    this.videoList = this.querySelector('.video-carousel__list');
    this.videos = this.querySelectorAll('video');
    this.playIcon = this.querySelectorAll('.video-carousel__play-button');

    if (window.accessibilityMode) {
      this.swiperLoader.remove();
      this.playIcon.forEach((icon) => {
        icon.remove();
      });
      this.videos.forEach((video) => {
        video.setAttribute('controls', true);
      });

      // Add CSS to make controls permanently visible in accessibility mode
      this.addPermanentControlsCSS();

      // Add class to video wrappers for CSS targeting
      this.querySelectorAll('.video-carousel__video-wrapper').forEach((wrapper) => {
        wrapper.classList.add('accessibility-video-controls');
      });
    } else {
      this.videoList.remove();
    }
  }

  // Method to add CSS for permanent video controls
  addPermanentControlsCSS() {
    if (!document.getElementById('video-accessibility-css')) {
      const style = document.createElement('style');
      style.id = 'video-accessibility-css';
      style.textContent = `
        .accessibility-video-controls video::-webkit-media-controls-panel {
          display: flex !important;
          opacity: 1 !important;
          visibility: visible !important;
          transform: none !important;
        }
        
        .accessibility-video-controls video::-webkit-media-controls {
          display: flex !important;
          opacity: 1 !important;
          visibility: visible !important;
        }
        
        .accessibility-video-controls video::-webkit-media-controls-timeline {
          display: flex !important;
        }
        
        .accessibility-video-controls video::--ms-media-controls-panel,
        .accessibility-video-controls video::-moz-media-controls-panel {
          display: flex !important;
          opacity: 1 !important;
        }
        
        .accessibility-video-controls video {
          --controls-visibility: visible !important;
        }
      `;
      document.head.appendChild(style);
    }
  }

  connectedCallback() {
    this.videos.forEach(($video) => {
      $video.addEventListener('click', () => {
        if ($video.paused) {
          $video.play();
          $video.classList.add('playing');

          // Focus the video when it starts playing in accessibility mode
          // This helps screen readers access the controls
          if (window.accessibilityMode) {
            $video.focus();
          }
        } else {
          $video.pause();
          $video.classList.remove('playing');
        }
      });
    });

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const video = entry.target;
            // Assign the poster attribute from data-poster, triggering its load
            video.poster = video.dataset.poster;

            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if (isSafari) {
              const videoWrapper = video.closest('.video-carousel__video-wrapper');
              videoWrapper.style.backgroundImage = `url(${video.dataset.poster})`;
            }

            obs.unobserve(video);
          }
        });
      },
      { rootMargin: '200px' }
    );

    this.videos.forEach((video) => observer.observe(video));
  }
}

defineElement('video-carousel', VideoCarousel);
